export enum OrganisationUnitTypeModel
{
  Location = 1,
  Department = 2
}
